import { render, staticRenderFns } from "./alignmentData.vue?vue&type=template&id=9ff930d8&scoped=true&"
import script from "./alignmentData.vue?vue&type=script&lang=js&"
export * from "./alignmentData.vue?vue&type=script&lang=js&"
import style0 from "./alignmentData.vue?vue&type=style&index=0&id=9ff930d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff930d8",
  null
  
)

export default component.exports